export default {
    AE: 'EAU',
    BO: 'Bolivia',
    CD: 'Congo',
    CF: 'Centroáfrica',
    FK: 'Islas Malvinas',
    FM: 'micronesia',
    GB: 'Reino Unido',
    GS: 'SGSSI',
    IO: 'BIOT',
    IR: 'Irán',
    KP: 'Corea del Norte',
    KR: 'Corea del Sur',
    LA: 'Laos',
    MD: 'Moldavia',
    MF: 'San Martín',
    PS: 'Palestina',
    RU: 'Rusia',
    SX: 'Sint Maarten',
    TW: 'Taiwán',
    TZ: 'Tanzania',
    US: 'EE.UU',
    VE: 'Venezuela',
    VG: 'Islas Vírgenes (británica)',
    VI: 'Islas Vírgenes (EEUU)',
};
